import { Directive, ElementRef, inject, input, OnInit, Renderer2 } from '@angular/core';
import { TFieldInputMode } from '../../model';

@Directive({
  selector: '[inputMode]',
  standalone: true
})
export class InputModeDirective implements OnInit {
  element = inject(ElementRef).nativeElement;

  inputMode = input<TFieldInputMode | undefined>();

  #renderer = inject(Renderer2);

  constructor() {}

  ngOnInit(): void {
    if (!this.inputMode()) {
      return;
    }

    /** render a native DOM "inputmode" attr on the input element to control type of
     * virtual keyboard layout ('numeric', 'tel', 'url' etc') */
    this.#renderer.setAttribute(this.element, 'inputmode', this.inputMode());
  }
}
